export default __webpack_public_path__ + "static/media/profile.4a97b9c9.svg";